import { render, staticRenderFns } from "./RulesSchedule.vue?vue&type=template&id=321879c8&lang=html"
import script from "./RulesSchedule.vue?vue&type=script&lang=js"
export * from "./RulesSchedule.vue?vue&type=script&lang=js"
import style0 from "./RulesSchedule.vue?vue&type=style&index=0&id=321879c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports